import React from "react";
import Map from "./Map.js";
import restart from "./../images/icons/replay_black_24dp.svg"
import guess from "./../images/icons/place_white_24dp.svg";

class MapWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.i18n = this.props.i18n;
    this.state = {
      //count: 0,
      lat: 0,
      lng: 0,
    };
    this.updateMarkerPos = this.updateMarkerPos.bind(this);
    this.startDrag = this.startDrag.bind(this);
    this.startLng = 0;
    this.startLat = 0;
  }

  updateMarkerPos(lat, lng) {
    this.props.registerMarkerMoved();
    this.setState({
      lat: lat,
      lng: lng,
    });
  }

  startDrag() {
    this.props.registerMarkerMoved();
    this.setState({
      lat: "...",
      lng: "..."
    });
  }

  render(props) {
    return (
      <div className="w-100 h-100 relative absolute top-0 left-0">
        <div className="w-100 h-100">
          <Map
            i18n={this.i18n}
            track={this.props.track}
            lat={this.startLat}
            lng={this.startLng}
            isInLine={this.props.isInLine}
            gameData={this.props.gameData}
            updateMarkerPos={this.updateMarkerPos}
            startDrag={this.startDrag}
            actualPosition={this.props.actualPosition}
            displayResult={this.props.displayResult}
            round={this.props.round}
            process={this.props.process}
            registerMapsLoaded={this.props.registerMapsLoaded}
          />
        </div>

        {this.props.process !== "end" ? (
          <div
            className={
              "absolute bottom-2-ns bottom-1 left-2-ns left-1 bg-white"
            }
          >
            <button
              onClick={() => {
                this.props.showDialog();
                // this.props.resetGame();
              }}
              className="flex secondary-btn img-btn items-center justify-center"
              id="restart"
            >
              <img src={restart} alt="Start again" />
              <p className="dn flex-ns pa0 ma0">{this.i18n.start_again}</p>
            </button>
          </div>
        ) : null}

        <div
          className={
            "absolute bottom-2-ns bottom-1 abs-center flex items-center flex-column justify-center " +
            (this.props.process === "guess" ? " o-100" : " o-0 usn ")
          }
        >
          {/* <p>
            Your guess: {this.state.lat}, {this.state.lng}
          </p> */}
          <button
            className={`flex img-btn items-center justify-center ${
              this.props.markerMoved && !this.props.hasGuessedAtLeastOnce
                ? "wiggle"
                : ""
            }`}
            onClick={() => {
              this.props.processGuess(this.state.lat, this.state.lng);
            }}
          >
            <img src={guess} alt="Guess" />
            <p className="pa0 ma0">{this.i18n.guess}</p>
          </button>
        </div>
        <div
          className={
            "absolute bottom-2-ns bottom-1 abs-center flex items-center flex-column justify-center " +
            (this.props.process === "guess" ? " o-0 usn " : " o-100")
          }
        >
          {this.props.process === "result" ? (
            <button
              className=""
              onClick={() => {
                this.props.nextRound();
              }}
            >
              {this.props.round < this.props.numRounds - 1
                ? this.i18n.next_round
                : this.i18n.see_score}
            </button>
          ) : (
            <div>
              {/* <button
                className="bg-custom-light custom-dark  "
                onClick={() => {
                  this.props.resetGame();
                }}
              >
                Play again
              </button>
              <button
                className="bg-custom-light ml2 custom-dark  "
                onClick={() => {
                  this.props.share();
                }}
              >
                Share your score
              </button> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MapWrapper;
